import _extends from "@babel/runtime/helpers/esm/extends";
import { darken, lighten, alpha, styled } from '@mui/material/styles';
import { gridClasses } from '../../constants/gridClasses';
export const GridRootStyles = styled('div', {
  name: 'MuiDataGrid',
  slot: 'Root',
  overridesResolver: (props, styles) => [{
    ["&.".concat(gridClasses.autoHeight)]: styles.autoHeight
  }, {
    ["& .".concat(gridClasses.editBooleanCell)]: styles.editBooleanCell
  }, {
    ["& .".concat(gridClasses['cell--editing'])]: styles['cell--editing']
  }, {
    ["& .".concat(gridClasses['cell--textCenter'])]: styles['cell--textCenter']
  }, {
    ["& .".concat(gridClasses['cell--textLeft'])]: styles['cell--textLeft']
  }, {
    ["& .".concat(gridClasses['cell--textRight'])]: styles['cell--textRight']
  },
  // TODO v6: Remove
  {
    ["& .".concat(gridClasses['cell--withRenderer'])]: styles['cell--withRenderer']
  }, {
    ["& .".concat(gridClasses.cell)]: styles.cell
  }, {
    ["& .".concat(gridClasses.cellContent)]: styles.cellContent
  }, {
    ["& .".concat(gridClasses.cellCheckbox)]: styles.cellCheckbox
  }, {
    ["& .".concat(gridClasses.checkboxInput)]: styles.checkboxInput
  }, {
    ["& .".concat(gridClasses['columnHeader--alignCenter'])]: styles['columnHeader--alignCenter']
  }, {
    ["& .".concat(gridClasses['columnHeader--alignLeft'])]: styles['columnHeader--alignLeft']
  }, {
    ["& .".concat(gridClasses['columnHeader--alignRight'])]: styles['columnHeader--alignRight']
  }, {
    ["& .".concat(gridClasses['columnHeader--dragging'])]: styles['columnHeader--dragging']
  }, {
    ["& .".concat(gridClasses['columnHeader--moving'])]: styles['columnHeader--moving']
  }, {
    ["& .".concat(gridClasses['columnHeader--numeric'])]: styles['columnHeader--numeric']
  }, {
    ["& .".concat(gridClasses['columnHeader--sortable'])]: styles['columnHeader--sortable']
  }, {
    ["& .".concat(gridClasses['columnHeader--sorted'])]: styles['columnHeader--sorted']
  }, {
    ["& .".concat(gridClasses.columnHeader)]: styles.columnHeader
  }, {
    ["& .".concat(gridClasses.columnHeaderCheckbox)]: styles.columnHeaderCheckbox
  }, {
    ["& .".concat(gridClasses.columnHeaderDraggableContainer)]: styles.columnHeaderDraggableContainer
  }, {
    ["& .".concat(gridClasses.columnHeaderTitleContainer)]: styles.columnHeaderTitleContainer
  }, {
    ["& .".concat(gridClasses['columnSeparator--resizable'])]: styles['columnSeparator--resizable']
  }, {
    ["& .".concat(gridClasses['columnSeparator--resizing'])]: styles['columnSeparator--resizing']
  }, {
    ["& .".concat(gridClasses.columnSeparator)]: styles.columnSeparator
  }, {
    ["& .".concat(gridClasses.filterIcon)]: styles.filterIcon
  }, {
    ["& .".concat(gridClasses.iconSeparator)]: styles.iconSeparator
  }, {
    ["& .".concat(gridClasses.menuIcon)]: styles.menuIcon
  }, {
    ["& .".concat(gridClasses.menuIconButton)]: styles.menuIconButton
  }, {
    ["& .".concat(gridClasses.menuOpen)]: styles.menuOpen
  }, {
    ["& .".concat(gridClasses.menuList)]: styles.menuList
  }, {
    ["& .".concat(gridClasses['row--editable'])]: styles['row--editable']
  }, {
    ["& .".concat(gridClasses['row--editing'])]: styles['row--editing']
  }, {
    ["& .".concat(gridClasses.row)]: styles.row
  }, {
    ["& .".concat(gridClasses.sortIcon)]: styles.sortIcon
  }, {
    ["& .".concat(gridClasses.withBorder)]: styles.withBorder
  }, {
    ["& .".concat(gridClasses.treeDataGroupingCell)]: styles.treeDataGroupingCell
  }, {
    ["& .".concat(gridClasses.treeDataGroupingCellToggle)]: styles.treeDataGroupingCellToggle
  }, {
    ["& .".concat(gridClasses.detailPanelToggleCell)]: styles.detailPanelToggleCell
  }, {
    ["& .".concat(gridClasses['detailPanelToggleCell--expanded'])]: styles['detailPanelToggleCell--expanded']
  }, styles.root]
})(_ref => {
  let {
    theme
  } = _ref;
  const borderColor = theme.palette.mode === 'light' ? lighten(alpha(theme.palette.divider, 1), 0.88) : darken(alpha(theme.palette.divider, 1), 0.68);
  const gridStyle = _extends({
    flex: 1,
    boxSizing: 'border-box',
    position: 'relative',
    border: "1px solid ".concat(borderColor),
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.text.primary
  }, theme.typography.body2, {
    outline: 'none',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    ["&.".concat(gridClasses.autoHeight)]: {
      height: 'auto',
      ["& .".concat(gridClasses['row--lastVisible'], " .").concat(gridClasses.cell)]: {
        borderBottomColor: 'transparent'
      }
    },
    ["& .".concat(gridClasses['virtualScrollerContent--overflowed'], " .").concat(gridClasses['row--lastVisible'], " .").concat(gridClasses.cell)]: {
      borderBottomColor: 'transparent'
    },
    ["& .".concat(gridClasses.columnHeader, ", & .").concat(gridClasses.cell)]: {
      WebkitTapHighlightColor: 'transparent',
      lineHeight: null,
      padding: '0 10px',
      boxSizing: 'border-box'
    },
    ["& .".concat(gridClasses.columnHeader, ":focus-within, & .").concat(gridClasses.cell, ":focus-within")]: {
      outline: "solid ".concat(alpha(theme.palette.primary.main, 0.5), " 1px"),
      outlineWidth: 1,
      outlineOffset: -1
    },
    ["& .".concat(gridClasses.columnHeader, ":focus, & .").concat(gridClasses.cell, ":focus")]: {
      outline: "solid ".concat(theme.palette.primary.main, " 1px")
    },
    ["& .".concat(gridClasses.columnHeaderCheckbox, ", & .").concat(gridClasses.cellCheckbox)]: {
      padding: 0,
      justifyContent: 'center',
      alignItems: 'center'
    },
    ["& .".concat(gridClasses.columnHeader)]: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },
    ["& .".concat(gridClasses['columnHeader--sorted'], " .").concat(gridClasses.iconButtonContainer, ", & .").concat(gridClasses['columnHeader--filtered'], " .").concat(gridClasses.iconButtonContainer)]: {
      visibility: 'visible',
      width: 'auto'
    },
    ["& .".concat(gridClasses.columnHeader, ":not(.").concat(gridClasses['columnHeader--sorted'], ") .").concat(gridClasses.sortIcon)]: {
      opacity: 0,
      transition: theme.transitions.create(['opacity'], {
        duration: theme.transitions.duration.shorter
      })
    },
    ["& .".concat(gridClasses.columnHeader, ":not(.").concat(gridClasses['columnHeader--sorted'], "):hover .").concat(gridClasses.sortIcon)]: {
      opacity: 0.5
    },
    ["& .".concat(gridClasses.columnHeaderTitleContainer)]: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 0,
      flex: 1,
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    },
    ["& .".concat(gridClasses.columnHeaderTitleContainerContent)]: {
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center'
    },
    ["& .".concat(gridClasses.sortIcon, ", & .").concat(gridClasses.filterIcon)]: {
      fontSize: 'inherit'
    },
    ["& .".concat(gridClasses['columnHeader--sortable'])]: {
      cursor: 'pointer'
    },
    ["& .".concat(gridClasses['columnHeader--alignCenter'], " .").concat(gridClasses.columnHeaderTitleContainer)]: {
      justifyContent: 'center'
    },
    ["& .".concat(gridClasses['columnHeader--alignRight'], " .").concat(gridClasses.columnHeaderDraggableContainer, ", & .").concat(gridClasses['columnHeader--alignRight'], " .").concat(gridClasses.columnHeaderTitleContainer)]: {
      flexDirection: 'row-reverse'
    },
    ["& .".concat(gridClasses['columnHeader--alignCenter'], " .").concat(gridClasses.menuIcon, ", & .").concat(gridClasses['columnHeader--alignRight'], " .").concat(gridClasses.menuIcon)]: {
      marginRight: 'auto',
      marginLeft: -6
    },
    ["& .".concat(gridClasses['columnHeader--alignRight'], " .").concat(gridClasses.menuIcon, ", & .").concat(gridClasses['columnHeader--alignRight'], " .").concat(gridClasses.menuIcon)]: {
      marginRight: 'auto',
      marginLeft: -10
    },
    ["& .".concat(gridClasses['columnHeader--moving'])]: {
      backgroundColor: theme.palette.action.hover
    },
    ["& .".concat(gridClasses.columnSeparator)]: {
      position: 'absolute',
      zIndex: 100,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      color: borderColor
    },
    ["& .".concat(gridClasses['columnSeparator--sideLeft'])]: {
      left: -12
    },
    ["& .".concat(gridClasses['columnSeparator--sideRight'])]: {
      right: -12
    },
    ["& .".concat(gridClasses['columnSeparator--resizable'])]: {
      cursor: 'col-resize',
      touchAction: 'none',
      '&:hover': {
        color: theme.palette.text.primary,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          color: borderColor
        }
      },
      ["&.".concat(gridClasses['columnSeparator--resizing'])]: {
        color: theme.palette.text.primary
      }
    },
    ["& .".concat(gridClasses.iconSeparator)]: {
      color: 'inherit'
    },
    ["& .".concat(gridClasses.menuIcon)]: {
      width: 0,
      visibility: 'hidden',
      fontSize: 20,
      marginRight: -10,
      display: 'flex',
      alignItems: 'center'
    },
    ["& .".concat(gridClasses.columnHeader, ":hover")]: {
      ["& .".concat(gridClasses.iconButtonContainer)]: {
        visibility: 'visible',
        width: 'auto'
      },
      ["& .".concat(gridClasses.menuIcon)]: {
        width: 'auto',
        visibility: 'visible'
      }
    },
    [".".concat(gridClasses.menuOpen)]: {
      visibility: 'visible',
      width: 'auto'
    },
    ["& .".concat(gridClasses.row)]: {
      display: 'flex',
      width: 'fit-content',
      breakInside: 'avoid',
      // Avoid the row to be broken in two different print pages.
      '&:hover, &.Mui-hovered': {
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&.Mui-selected': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
        '&:hover, &.Mui-hovered': {
          backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
          }
        }
      }
    },
    ["& .".concat(gridClasses.cell)]: {
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      borderBottom: "1px solid ".concat(borderColor)
    },
    ["& .".concat(gridClasses.cellContent)]: {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    ["& .".concat(gridClasses.cell, ".").concat(gridClasses['cell--editing'])]: {
      padding: 1,
      display: 'flex',
      boxShadow: theme.shadows[2],
      backgroundColor: theme.palette.background.paper,
      '&:focus-within': {
        outline: "solid ".concat(theme.palette.primary.main, " 1px"),
        outlineOffset: '-1px'
      }
    },
    ["& .".concat(gridClasses['row--editing'])]: {
      boxShadow: theme.shadows[2]
    },
    ["& .".concat(gridClasses['row--editing'], " .").concat(gridClasses.cell)]: {
      boxShadow: theme.shadows[0],
      backgroundColor: theme.palette.background.paper
    },
    ["& .".concat(gridClasses.editBooleanCell)]: {
      display: 'flex',
      height: '100%',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center'
    },
    ["& .".concat(gridClasses.booleanCell, "[data-value=\"true\"]")]: {
      color: theme.palette.text.secondary
    },
    ["& .".concat(gridClasses.booleanCell, "[data-value=\"false\"]")]: {
      color: theme.palette.text.disabled
    },
    ["& .".concat(gridClasses.actionsCell)]: {
      display: 'inline-flex',
      alignItems: 'center',
      gridGap: theme.spacing(1)
    },
    ["& .".concat(gridClasses.withBorder)]: {
      borderRight: "1px solid ".concat(borderColor)
    },
    ["& .".concat(gridClasses['cell--textLeft'])]: {
      justifyContent: 'flex-start'
    },
    ["& .".concat(gridClasses['cell--textRight'])]: {
      justifyContent: 'flex-end'
    },
    ["& .".concat(gridClasses['cell--textCenter'])]: {
      justifyContent: 'center'
    },
    ["& .".concat(gridClasses.columnHeaderDraggableContainer)]: {
      display: 'flex',
      width: '100%'
    },
    ["& .".concat(gridClasses['columnHeader--dragging'])]: {
      background: theme.palette.background.paper,
      padding: '0 12px',
      borderRadius: theme.shape.borderRadius,
      opacity: theme.palette.action.disabledOpacity
    },
    ["& .".concat(gridClasses.treeDataGroupingCell)]: {
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    },
    ["& .".concat(gridClasses.treeDataGroupingCellToggle)]: {
      flex: '0 0 28px',
      alignSelf: 'stretch',
      marginRight: theme.spacing(2)
    },
    ["& .".concat(gridClasses.groupingCriteriaCell)]: {
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    },
    ["& .".concat(gridClasses.groupingCriteriaCellToggle)]: {
      flex: '0 0 28px',
      alignSelf: 'stretch',
      marginRight: theme.spacing(2)
    }
  });
  return gridStyle;
});